import curry from 'ramda/src/curry';
import values from 'ramda/src/values';
import addIndex from 'ramda/src/addIndex';
import groupBy from 'ramda/src/groupBy';

// https://github.com/ramda/ramda/wiki/Cookbook#separate-a-list-into-n-parts
const separate = curry((n, list) => {
  const len = list.length;
  const f = (_v, idx) => Math.floor((idx * n) / len);
  return values(addIndex(groupBy)(f, list));
});

const splitData = (data, maxColumns) => {
  if (data.length <= 3) return [data];
  return separate(maxColumns, data);
};

export default splitData;
